import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config.json';
import { createAuth } from '../Helpers';
import { Team } from '../domain/Team';

export const reducerName = 'teamState';

export interface TeamState {
    teams: Team[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

export const getAllTeams = createAsyncThunk<Team[], void, { rejectValue: string }>(
    'teamState/getAllTeams',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/team`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            const err = error as any;
            console.log('ERROR FETCHING TEAMS', err);
            return rejectWithValue(err.response?.data || 'An error occurred');
        }
    }
);

const initialState: TeamState = {
    teams: [],
    status: 'idle',
    error: null,
};

const teamSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTeams.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllTeams.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.teams = action.payload;
            })
            .addCase(getAllTeams.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default teamSlice.reducer;